import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useWallet } from "../wallet/WalletProvider";
import { shortAddress } from "../overlay/format";

/** / — landing and login (§7.1 step 1). */
export function Landing() {
  const { ready, wallet, auth, authenticating, error, externalWallets, loginWithPrivy, connectExternal } = useWallet();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth && new URLSearchParams(window.location.search).get("next") === "play") navigate("/play");
  }, [auth, navigate]);

  return (
    <main className="page landing">
      <section className="hero">
        <h1>RedChain</h1>
        <p className="lead">
          Play your own Pokémon Red or Blue in the browser. Your saves sync to Solana: the Pokémon you catch become NFTs you own, and the ₽ you earn is
          real in-game RCD.
        </p>
        <ul className="bullets">
          <li>Bring your own ROM — it never leaves your device.</li>
          <li>Save as usual. Money, rare items and catches also auto-save, so they reach the chain within seconds.</li>
          <li>No browser extension needed: log in with email, Google, Apple or Discord, or use any Solana wallet.</li>
        </ul>
      </section>

      <section className="card login">
        {!ready && <p>Loading…</p>}
        {ready && auth && wallet && (
          <>
            <p>
              Logged in as <code>{shortAddress(wallet.address)}</code> ({wallet.kind === "privy" ? "game wallet" : "external wallet"}).
            </p>
            <Link className="button primary" to="/play">
              {auth.player.registered ? "Play" : "Create your trainer account"}
            </Link>
          </>
        )}
        {ready && !auth && (
          <>
            <h2>Log in</h2>
            <button className="primary" disabled={authenticating} onClick={loginWithPrivy}>
              Email, Google, Apple or Discord
            </button>
            <p className="hint">Creates a self-custodial game wallet you can export any time.</p>
            {externalWallets.length > 0 && (
              <>
                <h3>Or use a Solana wallet</h3>
                <div className="wallets">
                  {externalWallets.map((w) => (
                    <button key={w.name} disabled={authenticating} onClick={() => void connectExternal(w.name)}>
                      <img src={w.icon} alt="" width={20} height={20} /> {w.name}
                    </button>
                  ))}
                </div>
              </>
            )}
            {authenticating && <p className="status">Signing in…</p>}
          </>
        )}
        {error && <p className="status error">{error}</p>}
      </section>
    </main>
  );
}
